export default "__VITE_ASSET__BniUGWs0__"